import { TournamentState } from 'vue';
import { GetterTree } from 'vuex';

const getters: GetterTree<TournamentState, TournamentState> = {
  update: (state) => state.update,
  getTournament: (state) => state.tournament,
  getMatch: (state) => state.match,
  getPositionById: (state, id: number) => state.tournament.positions.find((pos) => pos.id === id),
  getMatchPosIndexes: (state) => {
    try {
      return new Set([state.match.posLeft.posIndex, state.match.posRight.posIndex]);
    } catch (error) {
      return new Set();
    }
  },
  getTournamentSocket: (state) => state.tournamentSocket,
  getEndeds: (state) => state.ended,
  getTrendings: (state) => state.trending,
};

export default getters;
